var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPmVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8443 10.995L13.7065 20.99H11.1205L13.2586 10.995H15.8443ZM26.723 17.4489L28.0839 13.6956L28.8672 17.4489H26.723ZM29.609 20.99H32L29.9111 10.995H27.7056C27.2086 10.995 26.7895 11.2832 26.6041 11.7277L22.7242 20.99H25.4398L25.9789 19.4973H29.2959L29.609 20.99ZM22.8588 17.727C22.8701 15.0891 19.2123 14.943 19.2368 13.7644C19.2447 13.4063 19.5864 13.0248 20.3332 12.9272C20.7034 12.8796 21.7252 12.8409 22.8833 13.3746L23.3363 11.2542C22.7143 11.0292 21.9138 10.8125 20.9177 10.8125C18.3614 10.8125 16.5632 12.1703 16.5489 14.1162C16.5324 15.5552 17.8334 16.3575 18.8115 16.8368C19.82 17.3266 20.1578 17.6407 20.1529 18.0784C20.1459 18.7489 19.3488 19.0459 18.6065 19.0571C17.3058 19.0774 16.5518 18.7056 15.9509 18.4254L15.4815 20.6166C16.0867 20.8936 17.2017 21.1345 18.3563 21.1469C21.0739 21.1469 22.8508 19.8051 22.8588 17.727ZM12.1495 10.995L7.95982 20.99H5.22689L3.165 13.0133C3.04001 12.5228 2.93098 12.3425 2.55084 12.1352C1.92903 11.7976 0.902583 11.4817 0 11.2853L0.0611471 10.995H4.46099C5.02142 10.995 5.52565 11.368 5.65402 12.0136L6.74318 17.7978L9.43295 10.995H12.1495Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmVisaIcon);
export default __webpack_public_path__ + "static/media/pm-visa-icon.587e5cd658463c667de3ef09ed27b5f9.svg";
export { ForwardRef as ReactComponent };